import React, {useEffect, useState} from "react";
import Close from "../icons/Close";
import Search from "../icons/Search";
import client from "../utils/client";
import TAGS from "../queries/tags";
import CATEGORIES from "../queries/categories";
import getIds from "../utils/getIds";
import LISTING_LIST from "../queries/listingList";
import Listing from "./Listing";
import {getFav} from "../../components/favourites";
import LISTINGS_BY_IDS from "../queries/listingsById";

const TAB_LISTINGS = 'TAB_LISTINGS';
const TAB_FAVOURITES = 'TAB_FAVOURITES';
const TAB_SEARCH = 'TAB_SEARCH';

const ItineraryFinderPopup = (props) => {

    const {
        title,
        type,
        onAdd,
        onClose,
    } = props;

    const [listings, setListings] = useState([]);
    const [tab, setTab] = useState(TAB_LISTINGS);
    const [keywords, setKeywords] = useState('');
    const [tag, setTag] = useState(null)
    const [categories, setCategories] = useState([]);
    const [tags, setTags] = useState([]);
    const [init, setInit] = useState(false);
    const [abortController, setAbortController] = useState();
    const [loading, setLoading] = useState(false);



    useEffect(() => {

        client.query({
            query: CATEGORIES,
            variables: {
                all: true
            }
        }).then(({data}) => {
            const filtered = data.categories.filter((c) => {
                return c.Type === type;
            });
            setCategories(filtered);

            client.query({
                query: TAGS,
                variables: {
                    filterEnabled: true,
                    hasListings: true,
                    categories: getIds(filtered, 'Identifier')
                }
            }).then(({data}) => {
                console.log(data);
                setTags(data.tags);
                setInit(true);
            });

        })


    }, []);

    useEffect(() => {
        if (init) {
            searchListings();
        }
    }, [init, tab, tag, keywords])

    const searchListings = () => {

        if (abortController) {
            abortController.abort();
        }

        let ac = new AbortController();
        setAbortController(ac);
        setLoading(true);

        if (tab === TAB_FAVOURITES) {
            const fIds = getFav();
            if (fIds.length > 0) {
                client.query({
                    query: LISTINGS_BY_IDS,
                    variables: {
                        ids: getFav()
                    },
                    fetchOptions: {
                        signal: ac.signal,
                    }
                }).then(({data}) => {
                    const ls = [];
                    const cIds = getIds(categories, 'Identifier');
                    data.listingsById.map((listing) => {
                        const mc = listing.MainCategory;
                        if (cIds.indexOf(mc.Identifier) >= 0) {
                            ls.push(listing);
                        }
                    });
                    setListings(ls);
                    setLoading(false);
                });
            } else {
                setListings([]);
                setLoading(false);
            }
        } else {
            setListings([]);
            client.query({
                query: LISTING_LIST,
                variables: {
                    tags: tag ? [tag] : undefined,
                    categories: getIds(categories, 'Identifier'),
                    keywords: keywords,
                    limit: 100
                },
                context: {
                    fetchOptions: {
                        signal: ac.signal,
                    }
                }
            }).then(({data}) => {
                const ls = [];
                data.listings.edges.map((l) => {
                    ls.push(l.node);
                });
                setListings(ls);
                setLoading(false);
            })
        }
    };

    return <>
        <div className={'itn__search'}>
            <div className={'itn__search__wrap'}>
                <div className={'itn__search__inner'}>
                    <div className={'itn__search__title'}>
                        <h2>{title}</h2>
                        <button
                            onClick={() => {
                                onClose();
                            }}
                            className={'itn__search__close'}>
                            <span>Close</span>
                            <span className={'icon'}>
                                <Close />
                            </span>
                        </button>
                    </div>
                    <div className={'itn__search-tabs'}>
                        <ul>
                            <li><button
                                className={tab === TAB_LISTINGS ? 'active' : ''}
                                onClick={() => {
                                    setKeywords(null);
                                    setTag(null);
                                    setTab(TAB_LISTINGS);
                                }}><span>All Listings</span></button></li>
                            <li><button
                                className={tab === TAB_FAVOURITES ? 'active' : ''}
                                onClick={() => {
                                    setKeywords(null);
                                    setTag(null);
                                    setTab(TAB_FAVOURITES);
                                }}><span>My Favourites</span></button></li>
                            <li className="itn__search-tabs__search"><button
                                className={tab === TAB_SEARCH ? 'active search' : 'search'}
                                onClick={() => {
                                    setKeywords(null);
                                    setTag(null);
                                    setTab(TAB_SEARCH);
                                }}><span>Search</span> <Search /></button></li>
                        </ul>
                    </div>


                    <div className={'itn__results'}>

                        {tab === TAB_SEARCH && <div className={'itn__results__search'}>
                            <input
                                type={'text'}
                                value={keywords}
                                placeholder="Search"
                                onChange={(e) => {
                                    setKeywords(e.target.value);
                                }}
                            />
                            <Search />
                        </div>}

                        <div className={'itn__results__title'}>
                            {tab === TAB_FAVOURITES && <div className="itn__results__title__wrap">
                                <h3>My `{title}` Favourites</h3>
                                <div className="itn__popup__filter">
                                    <select>
                                        <option>Filter Tags</option>
                                    </select>
                                </div>
                            </div>}
                            {tab === TAB_SEARCH && <div className="itn__results__title__wrap">
                                <h3>Search Results:</h3>
                                {tags.length > 0 && <div className="itn__popup__filter">
                                    <select>
                                        <option>Filter Tags</option>
                                        {tags.map((tag) => {
                                            return <option value={tag.Identifier}>
                                                {tag.Title}
                                            </option>
                                        })}
                                    </select>
                                </div>}
                            </div>}
                            {(tab == TAB_LISTINGS && tags.length > 0) && <div className="itn__popup__filter">
                                <select
                                    value={tag}
                                    onChange={(e) => {
                                        setTag(e.target.value);
                                    }}
                                >
                                    <option>Filter Tags</option>
                                    {tags.map((tag) => {
                                        return <option value={tag.Identifier}>
                                            {tag.Title}
                                        </option>
                                    })}
                                </select>
                            </div>}
                        </div>

                        {listings.length > 0 && <>
                            <div className={'itn__r-list'}>
                                {listings.map((l, i) => {
                                    return <div key={l.Identifier} className={'itn__r-item'}>
                                        <Listing
                                            listing={l}
                                            displayFeatures={false}
                                            finderPopup={true}
                                            nofFeaturedListings={0}
                                            index={i}
                                            itinerary={true}
                                            onClick={() => {
                                                onAdd(l);
                                            }}
                                        />
                                    </div>
                                })}
                            </div>
                        </>}

                        {loading && <>
                            <div className={'itn__loading'}>
                                <div className="loading__wrap">
                                    <div>
                                        <div className="loaderContainer">
                                            <div className="customLoader"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>}
                    </div>
                </div>
            </div>
        </div>
        <div className={'itn__backdrop'}></div>
    </>

}

export default ItineraryFinderPopup;
